export enum UserPermission {
  PROVIDE_AI_FEEDBACK = 'PROVIDE_AI_FEEDBACK',
}
